"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedImpl = exports.pass = void 0;
/**
 * A helper function for variantModule.
 *
 * This is the identity function by a better name.
 * @param x
 */
const pass = (x) => x;
exports.pass = pass;
function typedImpl(_key) {
    function typed(defOrFactory) {
        if (typeof defOrFactory === 'function') {
            return defOrFactory(exports.pass);
        }
        else {
            return defOrFactory;
        }
    }
    return { typed };
}
exports.typedImpl = typedImpl;
